import Quill from 'quill';

const Inline: {
  new(domNode, value);
  value(domNode);
  create(value);
  formats(value);
} = Quill.import('blots/inline');

/**
 * Quill/Parchment Blot to allow block shortcode placeholders
 * @class BlockShortcode
 * @extends BlockEmbed
 */
export class InlineShortcodeBlot extends Inline {
  /** @inheritdoc */
  static blotName: string = 'inlineShortcode';

  /** @inheritdoc */
  static tagName: string = 'SPAN';

  /** @inheritdoc */
  static create(value) {
    const node = super.create(value);

    for (const attr of value) {
      node.setAttribute(attr.nodeName, attr.nodeValue);
    }
    return node;
  }

  /** @inheritdoc */
  static value(domNode) {
    return domNode;
  }

  /** @inheritdoc */
  static formats(domNode) {
    if (this.isShortcode(domNode)) {
      return domNode.attributes;
    }
    return super.formats(domNode);
  }

  /**
   * Checks to see if the dataset or the value has a data-shortcode
   * @param {any} value value from the formats or the domNode
   * @returns {boolean}
   */
  static isShortcode(value) {
    return (value.dataset && value.dataset.shortcode) || !!value['data-shortcode'];
  }

  /**
   * Key value pair of the donNode's dataset
   */
  data: DOMStringMap;

  /**
   * The model tag that gets passed in
   */
  modelTag: HTMLElement;

  constructor(public domNode: any, value?: any) {
    super(domNode, value);
    if (InlineShortcodeBlot.isShortcode(domNode)) {
      this.data = domNode.dataset;
      this.modelTag = domNode;
    }
  }

  setDataAttributes(domNode, dataset?: DOMStringMap): void {
    const data = {...this.data, ...dataset};
    Object.keys(data).forEach((key) => {
      domNode.setAttribute(`data-${key}`.camelToHyphen(), data[key]);
    });
  }

  getModelTag(domNode): HTMLElement {
    return this.modelTag;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/shortcode/inline/inline.shortcode.blot.ts